import { IState } from '../store';

export function isDealRent(state: IState) {
  const { offer } = state.offerData;

  return Boolean(offer.isByHomeowner && offer.flags && offer.flags.isDealRent);
}
